export const criticalStylesheets = [
  "/css/bootstrap.min.css",
  "/css/styles.min.css",
];

export const deferredStylesheets = [
  "/icons/icomoon/style.css",
  "/css/animate.min.css",
  "/css/odometer.min.css",
  "/css/swiper-bundle.min.css",
];
